<div
    class="confirmation-overlay"
    [class.show]="visible"
>
    <div class="confirmation-box">
        <h2 class="confirmation-message">{{ message }}</h2>
        <div class="confirmation-actions">
            <button
                mat-raised-button
                class="confirm-button"
                (click)="onConfirm()"
            >
                {{ confirmText }}
            </button>
            <button
                mat-raised-button
                class="cancel-button"
                (click)="onCancel()"
            >
                {{ cancelText }}
            </button>
        </div>
    </div>
</div>
